<template>
  <div class="site_content_barometer">
    <div class="flex combo_box">
        <v-select dense outlined
          id="farm"
          ref="farm"
          class="select_farm"
          prepend-inner-icon="mdi-home-circle"
          v-model="farm"
          :items="farmItems"
          :menu-props="{ top: false, offsetY: true }"
          no-data-text="자료(권한)이 없습니다."
          item-text="name"
          return-object
          @change="changeFarm()"
          @focus="comboFarms()"
          clearable
        >
        </v-select>
        <div class="flex mb-combo">
          <v-select dense outlined
            id="building" 
            ref="building" 
            class="select_building"
            :label="bizBuilding_name"
            v-model="building"
            :items="buildingItems"
            :menu-props="{ top: false, offsetY: true }"
            no-data-text="자료(권한)이 없습니다."
            item-text="name"
            return-object
            @change="changeBuilding()"
            @focus="comboBuildings()"
            clearable
          >
        </v-select>
        <v-select dense outlined
            id="room" 
            ref="room" 
            class="select_room"
            :label="bizRoom_name"
            v-model="room"
            :items="roomItems"
            :menu-props="{ top: false, offsetY: true }"
            no-data-text="자료(권한)이 없습니다."
            item-text="name"
            return-object
            @change="changeRoom()"
            @focus="comboRooms()"
            clearable
          >
          </v-select>
        </div>
    </div>

    <div class="value_container">
      <div>
        <v-sheet class="timebar ml-2"
        >
          <v-slider 
            :loading="loading" 
            label="간격"
            color="#005B96"
            track-color="gray"
            v-model="term"
            :tick-labels="['1분', '1시간', '일별']"
            :max="2"
            step="1"
            ticks="always"
            tick-size="3"
            @change="refreshList()"
          ></v-slider>
        </v-sheet>
      </div>

      <div class="flex vertical-center mb-col">
        <div class="mb-flex flex vertical-center">
          <v-btn
            :disabled = "showList"
            class="ma-2 show__btn"
            @click="showList = true; refreshList()"
          >
            목록
            <v-icon right >mdi-view-list</v-icon>
          </v-btn>
          <v-btn
            :disabled = "!showList"
            class="ma-2 show__btn"
            @click="showList = false; refreshList()"
          >
            차트
            <v-icon right dark>mdi-chart-line</v-icon>
        </v-btn>
        </div>
        

        <div class="flex mb-picker">
          <datePicker
            :fr_date="fr_date" 
            :to_date="to_date" 
            @update:fr_date="updateFrDate"
            @update:to_date="updateToDate"
            @refresh="refreshData"
          />
        </div>
      </div>
    </div>

    <div class="barometer_container">
      <div v-show="!showList">
        <div v-if="this.term < 2">
          <Chart
          :key="chartKey" 
          :services="services"
          chartTypeY1="Line" 
          chartTypeY2="Line" 
          :buttonsY1="filteredButtonsY1"
          :buttonsY2="filteredButtonsY2"
          :trendData="trendData"
          :chartOptions="CompareLineOptions"
          :chartSize="chartSize"
          :y1DefaultValue="y1Value"
          :y2DefaultValue="y2Value"
        />
        </div>

        <div else>
          <div
            v-for="(data, i) in trendDataKeys"
            :key="i"
            v-show="hasDataForChart(data.type)"
            class="chart_layout"
          >
            <div>
              <span class="label">{{ data.label }}</span>
            </div>
            <DailyChart
              chartType="Line"
              :chart-data="getChartData(data)"
              :chartOptions="dailyLineOption"
              :chartSize="dailychartSize"
            />
          </div>
        </div> 
      </div>

      <div v-show="showList">
        <div v-if="this.term < 2">
          <Table 
            ref="timeTable"
            :items="filteredItems"
            :headers = "filterHeader"
            :loadingTable = "loading"
            :divisionTerm= "term"
            :search="search" 
          />
        </div>

       <div v-else>
          <DailyTable
          ref="dailyTable"
          :listData_daily="filteredDailyItems"
          :dailyHeader="dailyTableHeaders"
          :loadingTable = "loading"
          :search="search" 
          />
        </div>

        <div class="flex mb-search">
          <v-text-field dense class="shrink mr-2 search"
            clearable
            v-model="search"
            append-icon="mdi-magnify"
            label="날짜 또는 시간으로 골라보기"
            single-line
            hide-details
          ></v-text-field>

          <v-btn class="report__btn mt-1" @click="Report()" >
            <v-icon size="medium" color="white">mdi-file-document</v-icon>
            <span style="color:white;">엑셀다운 </span>
          </v-btn>
        </div>
       
      </div>
    </div>
  </div>
</template>

<script>
import * as Xlsx from 'xlsx'

import Apis from '@/api/apis'
import VueCookies from "vue-cookies";
import dateUtil from "@/utils/custom/dateProperty.js";

import datePicker from "@/components/compo/datePicker_day.vue";

import Chart from '@/components/chart/CompareChart.vue';
import Table from "@/components/compo/Table.vue";
import DailyChart from '@/components/chart/Chart.vue';
import DailyTable from '@/components/compo/dailyTable.vue';

import { CompareLineOptions, dailyLineOption } from "@/components/chart/option.js"; 

const term_list = [1, 60];

export default {
  name: 'Barometer',
  components: {
    datePicker,
    Chart,
    Table,
    DailyChart,
    DailyTable
  },
  async created() {
    Apis.pageCount({
      page_name: this.$route.name,
      url: this.$route.path,
      division: "cloud",
    },() => {  // 정상처리
      // console.log("pageCount 호출",res);
    }).catch( (err) => {  // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류",err);
    });

    await this.comboFarms();
    await this.comboBuildings();
    await this.comboRooms();

    let cdate = new Date();
    this.to_date= dateUtil.format(cdate, "yyyy-MM-dd");
    let frdate = new Date(cdate.setDate(cdate.getDate() - 6));
    this.fr_date= dateUtil.format(frdate, "yyyy-MM-dd");

    let cookie_info = VueCookies.get("barometer_info");
    if (cookie_info) {
      this.showList = cookie_info.showList;
      this.term = cookie_info.term;
    }
    if (!this.isNull(this.$route.params)) {
      // console.log("Params : ", this.$route.params);
      this.farm = this.$route.params.farm;
      this.building = this.$route.params.building;
      this.room = this.$route.params.room;
    } else if (cookie_info) {
      this.farm = cookie_info.farm || {};
      this.building = cookie_info.building || {};
      this.room = cookie_info.room || {};
    } else {
      this.room = this.roomItems[0];
      this.company = {code: this.room.company_cd, name: this.room.company_name};
      this.farm = {code: this.room.farm_cd, name: this.room.farm_name};
      this.building = {code: this.room.building_cd, name: this.room.building_name};
    }
    this.refreshData();
  },
  watch:{
    farm(newVal) {
      this.updateBizNames(newVal);
    },
    room(newVal){
      if (newVal && newVal.code) {
        this.refreshData();
      }
    },
    trendData: {
      deep: true, 
      handler() {
        this.chartKey = Date.now();
      }
    },
    services: {
      deep: true,
      handler() {
        this.updateDailyTableHeaders();
      },
    },
    listData_daily() {
      this.updateDailyTableHeaders();
    },
  },
  computed: {
    filteredButtonsY1() {
      return this.buttonsY1.filter(button => 
      (button.value !== 'w_temp' || term_list[this.term] !== 1) && this.hasData(button.value)
      );
    },
    filteredButtonsY2() {
      return this.buttonsY2.filter(button => 
        (button.value !== 'w_temp' || term_list[this.term] !== 1) && this.hasData(button.value)
      );
    },
    y1Name() {
      return this.getLabel(this.yv1Value);
    },
    y2Name() {
      return this.getLabel(this.y2Value);
    },

    // 검색어 날짜
    filteredItems() {
      if (!this.search) return this.listData;
      return this.listData.filter(item =>
        Object.values(item).some(value =>
          String(value).toLowerCase().includes(this.search.toLowerCase())
        )
      );
    },
    filteredDailyItems() {
      if (!this.search) return this.listData_daily;
      return this.listData_daily.filter(item =>
        Object.values(item).some(value =>
          String(value).toLowerCase().includes(this.search.toLowerCase())
        )
      );
    },
    //서비스 별 헤더 제공
    filterHeader() {
      let baseHeaders = [
        { text: '측정일', value: 'checkDate', show: true },
        { text: '측정시간',  value: 'checkTime', show: true },
        // { text: '온도 ℃', value: 'temp', show: true },
        // { text: '습도 %', value: 'hum', show: true },

      ];

      // 중복 추가 방지 함수
      const duplicationValue = (header) => {
        if (!baseHeaders.some(h => h.value === header.value)) {
          baseHeaders.push(header);
        }
      };

    // 데이터에 값이 존재하는지 확인
    // const nh3Data = this.listData.some(item => item.nh3 !== undefined && item.nh3 !== null);
    // const co2Data = this.listData.some(item => item.co2 !== undefined && item.co2 !== null);
    // const h2sData = this.listData.some(item => item.h2s !== undefined && item.h2s !== null);

    
    // // 서비스 조건과 데이터 존재 여부에 따라 헤더 추가
    // if (this.services.deodorizer) {
    //   if (co2Data) duplicationValue({ text: '이산화탄소 ppm', value: 'co2' });
    //   if (nh3Data) duplicationValue({ text: '암모니아 ppm', value: 'nh3'});
    //   if (h2sData) duplicationValue({ text: '황화수소 ppm', value: 'h2s'});
    // }

    // if (this.services.fancontrol) {
    //   if (co2Data) duplicationValue({ text: '이산화탄소 ppm', value: 'co2' });
    //   if (nh3Data) duplicationValue({ text: '암모니아 ppm', value: 'nh3'});
    // }

    // if (this.services.esg) {
    //   if (co2Data) duplicationValue({ text: '이산화탄소 ppm', value: 'co2' });
    //   if (nh3Data) duplicationValue({ text: '암모니아 ppm', value: 'nh3'});
    // }

    // listData에서 값이 존재하는지 확인
    const hasData = (key) => this.listData.some(item => item[key] !== undefined && item[key] !== null);

    // 존재하는 값에 따라 헤더 추가
    if (hasData('temp')) duplicationValue({ text: '온도 ℃', value: 'temp' });
    if (hasData('hum')) duplicationValue({ text: '습도 %', value: 'hum' });

    if (hasData('co2')) duplicationValue({ text: '이산화탄소 ppm', value: 'co2' });
    if (hasData('nh3')) duplicationValue({ text: '암모니아 ppm', value: 'nh3' });
    if (hasData('h2s')) duplicationValue({ text: '황화수소 ppm', value: 'h2s' });

    return baseHeaders;
  },
  },
  data () {
    return {
      chartKey: Date.now(),
      
      bizBuilding_name:"건물",
      bizRoom_name:"위치",

      showList: false,
      chartSize: {
        height:'100%',
        width: '100%',
      },
      dailychartSize: {
        height: '40px',
        width: '100%',
      },

      // y1Value: 'temp', 
      // y2Value: 'hum',
      y1Value: null, // 처음에는 null로 설정
      y2Value: null,
     //     headers: [],
      search:'',

      buttonsY1: [
        { value: 'temp', title: '온도', icon: require('@/assets/monitoring/icon/temp.svg'), activeClass: 'temp_active' },
        // { value: 'w_temp', title: '외기온도', icon: require('@/assets/monitoring/icon/outside_temp.svg'), activeClass: 'w_temp_active'},
        { value: 'hum', title: '습도', icon: require('@/assets/monitoring/icon/humidity.svg'), activeClass: 'hum_active' },
        { value: 'co2', title: '이산화탄소', icon: require('@/assets/monitoring/icon/co2.svg'), activeClass: 'co2_active' },
        { value: 'nh3', title: '암모니아', icon: require('@/assets/monitoring/icon/nh3.svg'), activeClass: 'nh3_active' },
        { value: 'h2s', title: '황화수소', icon: require('@/assets/monitoring/icon/h2s.svg'), activeClass: 'h2s_active' },
      ],
      buttonsY2: [
        { value: 'temp', title: '온도', icon: require('@/assets/monitoring/icon/temp.svg'), activeClass: 'temp_active' },
        { value: 'w_temp', title: '외기온도', icon: require('@/assets/monitoring/icon/outside_temp.svg'), activeClass: 'w_temp_active'},
        { value: 'hum', title: '습도', icon: require('@/assets/monitoring/icon/humidity.svg'), activeClass: 'hum_active' },
        { value: 'co2', title: '이산화탄소', icon: require('@/assets/monitoring/icon/co2.svg'), activeClass: 'co2_active' },
        { value: 'nh3', title: '암모니아', icon: require('@/assets/monitoring/icon/nh3.svg'), activeClass: 'nh3_active' },
        { value: 'h2s', title: '황화수소', icon: require('@/assets/monitoring/icon/h2s.svg'), activeClass: 'h2s_active' },
      ],
      CompareLineOptions:CompareLineOptions,
      dailyLineOption:dailyLineOption,

      trendData:{ },
      
      //일별 데이터
      trendDataKeys: [
        { type: "temp", label: "온도", color: "#8CC0DE" },
        { type: "hum", label: "습도", color: "#CCEEBC" },
        { type: "co2", label: "이산화탄소", color: "#FFD9C0" },
        { type: "nh3", label: "암모니아", color: "#FFD6A5" },
        { type: "h2s", label: "황화수소", color: "#D4E2D4" },
      ],

      animateChart: false,

      loading: false,
      company : {},
      companyItems : [],
      farm : {},
      farmItems : [],
      building : {},
      buildingItems : [],
      room : {},
      roomItems : [],
      farmBiz: null,

      term: 1,
      fr_date: "",
      to_date: "",

      listData: [],
      listData_daily: [],
      services:{},

      dailyTableHeaders: [],
      reportDailyData: [],
    }
  },
  methods: {
    updateBizNames(val){
      // console.log(val)
      if (val.biz === "CF02") {
        this.bizBuilding_name = "축사";
        this.bizRoom_name = "돈방";
      } else if (val.biz === "CF04") {
        this.bizBuilding_name = "계사";
        this.bizRoom_name = "구역";
      } else if (val.biz === "CF05" || val.biz === "CF06") {
        this.bizBuilding_name = "축사";
        this.bizRoom_name = "우사";
      }else {
        this.bizBuilding_name = "사업장";
        this.bizRoom_name = "위치";
    }
    },
    updateFrDate(date) {
      this.fr_date = date;
    },
    updateToDate(date) {
      this.to_date = date;
    },
    setY1Value(value) {
      this.y1Value = value;
    },
    setY2Value(value) {
      this.y2Value = value;
    },
    refreshData(){
      this.refreshList();
    },
    updateDailyTableHeaders() {
      this.dailyTableHeaders = this.filterDailyHeader();
    },
    hasData(value) {
      return this.trendData[value] && this.trendData[value].length > 0;
    },
    //일별 레포트
    updateReportDailyData(){
      this.reportDailyData = this.listData_daily.map((item) => ({
        checkDate: item.checkDate || "-",
        temp_highest: item.temp_highest || "-",
        temp_lowest: item.temp_lowest || "-",
        temp_average: item.temp_average || "-",
        hum_highest: item.hum_highest || "-",
        hum_lowest: item.hum_lowest || "-",
        hum_average: item.hum_average || "-",
        co2_highest: item.co2_highest || "-",
        co2_lowest: item.co2_lowest || "-",
        co2_average: item.co2_average || "-",
        nh3_highest: item.nh3_highest || "-",
        nh3_lowest: item.nh3_lowest || "-",
        nh3_average: item.nh3_average || "-",
        h2s_highest: item.h2s_highest || "-",
        h2s_lowest: item.h2s_lowest || "-",
        h2s_average: item.h2s_average || "-",
      }));
    },
    refreshList() {
      if  (!this.room || !this.room.code ) {
        alert("돈방/위치를 선택하세요");
        this.$refs.room.focus();
        return;
      }
      if  (!this.fr_date) {
        alert("조회 시작일 선택하세요");
        this.$refs.fr_date.focus();
        return;
      }
      if  (!this.to_date) {
        alert("조회 종료일 선택하세요");
        this.$refs.to_date.focus();
        return;
      }
      // 날짜 범위 계산
      const frDate = new Date(this.fr_date);
      const toDate = new Date(this.to_date);
      const diffTime = toDate - frDate;
      const diffDays = diffTime / (1000 * 60 * 60 * 24); // 밀리초를 일 단위로 변환

      if (diffDays > 90) {
        alert("조회 기간은 90일 이하로 선택해주세요");
        return;
      }
      
      this.$store.commit("resMessage","");
      this.loading = true;
      this.listData = [];
      this.listData_daily = [];
      this.trendData = {}; 

      //엑셀 일별
      this.reportDailyData = []; 

      if (this.term < 2) {
        Apis.room24hoursView({
          company_cd: this.company.code,
          farm_cd: this.farm.code,
          building_cd: this.building.code,
          room_cd: this.room.code,
          fr_dt: this.fr_date,
          to_dt: this.to_date,
          start_time: "00:00:00",
          end_time: "23:59:59",
          timeDivision: term_list[this.term],
          },(res) => {  
            if (res.result) {
              this.services = res.data.service;
              this.listData = res.data.datalist.reverse();
              // console.log(res.data)

              if (!this.showList) {
                let originalListData = [...res.data.datalist.reverse()];

                let time_temp = [];
                let temp_array = [];

                let time_hum = [];
                let hum_array = [];

                let time_co2 = [];
                let co2_array = [];

                let time_nh3 = [];
                let nh3_array = [];

                let time_h2s = [];
                let h2s_array = [];

                let wtemp_array = [];
              
                // console.log(originalListData);
                originalListData.forEach(function (item) {
                  if  (item.temp && !isNaN(item.temp)) time_temp.push(item.checkDateTime.substring(5,16));

                  if  (item.temp && !isNaN(item.temp)) temp_array.push(Number(item.temp))|| temp_array.push(null);
                  if  (item.w_temp && !isNaN(item.w_temp)) wtemp_array.push(Number(item.w_temp))|| wtemp_array.push(null);

                  if  (item.hum && !isNaN(item.hum)) time_hum.push(item.checkDateTime.substring(5,16));
                  if  (item.hum && !isNaN(item.hum)) hum_array.push(Number(item.hum))|| hum_array.push(null);

                  if  (item.co2 && !isNaN(item.co2)) time_co2.push(item.checkDateTime.substring(5,16));
                  if  (item.co2 && !isNaN(item.co2)) co2_array.push(Number(item.co2))|| co2_array.push(null);

                  if  (item.nh3 && !isNaN(item.nh3)) time_nh3.push(item.checkDateTime.substring(5,16));
                  if  (item.nh3 && !isNaN(item.nh3)) nh3_array.push(Number(item.nh3))|| nh3_array.push(null);

                  if (item.h2s !== null && item.h2s !== undefined && !isNaN(item.h2s)) time_h2s.push(item.checkDateTime.substring(5,16));
                  if (item.h2s !== null && item.h2s !== undefined && !isNaN(item.h2s))  h2s_array.push(Number(item.h2s))|| h2s_array.push(null);
                  
                }) 

                // console.log(this.listData);                
                this.trendData = {
                  term : this.term,
                  
                  time_temp : time_temp,
                  temp: temp_array,
                  
                  time_hum : time_hum,
                  hum: hum_array,

                  time_co2 : time_co2,
                  co2: co2_array,

                  time_nh3 : time_nh3,
                  nh3: nh3_array,

                  time_h2s : time_h2s,
                  h2s: h2s_array,

                  w_temp: wtemp_array
                }

                // 데이터 수에 따라서 Y1, Y2 value가 선택되게 
                this.$nextTick(() => {
                  const y1 = this.filteredButtonsY1;
                  const y2 = this.filteredButtonsY2;

                  // console.log(y1[0].value, y2[0].value)
                  this.y1Value = y1.length > 0 ? y1[0].value : null;
                  
                  this.y2Value = y1[0].value == y2[0].value ? y2[1].value : y2[0].value;

                  this.chartKey = Date.now();

                });

              }
              // console.log("데이터", this.trendData)
          
              this.$store.commit("resMessage",res.message);
              let cookie_info = { farm: this.farm, building: this.building, room: this.room,  showList: this.showList, term : this.term };
              VueCookies.set("barometer_info" ,cookie_info,"30d");
            } else {
              alert(res.message);
            }
            this.loading = false;
            // this.$re   fs.refreshList.focus();

          }).catch( (err) => {  // API 오류 처리
              console.log("room24hoursView API 호출 오류",err)
              alert(err);
              this.loading = false;
          }
        )
      } else {
        Apis.roomDailyViewServices({
          company_cd: this.company.code,
          farm_cd: this.farm.code,
          building_cd: this.building.code,
          room_cd: this.room.code,
          fr_date: this.fr_date,
          to_date: this.to_date,
          },(res) => {  
            if (res.result) {
              // console.log(this.listData_daily)
              this.listData_daily = res.data.daily.reverse();
              // console.log(this.listData_daily)
              this.services = res.data.service;
              this.dailyTableHeaders = [];

              this.updateReportDailyData();
              this.updateDailyTableHeaders(); 

              if (!this.showList) {
                if (Array.isArray(res.data.daily)) {
                let originalListData = [...res.data.daily.reverse()];
                // console.log("daily", res.data);

                let time_array = [];
                
                let temp_time = [];
                let temp_avg = [];
                let temp_low = [];
                let temp_high = [];

                let w_temp_avg = [];
                let w_temp_low = [];
                let w_temp_high = [];

                let hum_time = [];
                let hum_avg = [];
                let hum_low = [];
                let hum_high = [];

                let co2_time = [];
                let co2_avg = [];
                let co2_low = [];
                let co2_high = [];

                let nh3_time = [];
                let nh3_avg = [];
                let nh3_low = [];
                let nh3_high = [];

                let h2s_time = [];          
                let h2s_avg = [];
                let h2s_low = [];
                let h2s_high = [];

                originalListData.forEach(function (item) {
                  // console.log(res.data)
                  
                  time_array.push(item.checkDate.substring(5));

                  !isNaN(item.temp_average) && temp_time.push(item.checkDate.substring(5)) || "";
                  !isNaN(item.temp_average) && temp_avg.push( Number(item.temp_average)) || temp_avg.push(null);
                  !isNaN(item.temp_highest) && temp_high.push( Number(item.temp_highest)) || temp_high.push(null);
                  !isNaN(item.temp_lowest) && temp_low.push( Number(item.temp_lowest)) || temp_low.push(null);

                  !isNaN(item.w_temp_average) && w_temp_avg.push( Number(item.w_temp_average)) || w_temp_avg.push(null);
                  !isNaN(item.w_temp_highest) && w_temp_high.push( Number(item.w_temp_highest)) || w_temp_high.push(null);
                  !isNaN(item.w_temp_lowest) && w_temp_low.push( Number(item.w_temp_lowest)) || w_temp_low.push(null);

                  !isNaN(item.hum_average) && hum_time.push(item.checkDate.substring(5)) || "";
                  !isNaN(item.hum_average) && hum_avg.push( Number(item.hum_average)) || hum_avg.push(null);
                  !isNaN(item.hum_highest) && hum_high.push( Number(item.hum_highest)) || hum_high.push(null);
                  !isNaN(item.hum_lowest) && hum_low.push( Number(item.hum_lowest)) || hum_low.push(null);

                  !isNaN(item.co2_average) && co2_time.push(item.checkDate.substring(5)) || "";
                  !isNaN(item.co2_average) && co2_avg.push( Number(item.co2_average)) || co2_avg.push(null);
                  !isNaN(item.co2_highest) && co2_high.push( Number(item.co2_highest)) || co2_high.push(null);
                  !isNaN(item.co2_lowest) && co2_low.push( Number(item.co2_lowest)) || co2_low.push(null);

                  !isNaN(item.nh3_average) && nh3_time.push(item.checkDate.substring(5)) || "";
                  !isNaN(item.nh3_average) && nh3_avg.push( Number(item.nh3_average)) || nh3_avg.push(null);
                  !isNaN(item.nh3_highest) && nh3_high.push( Number(item.nh3_highest)) || nh3_high.push(null);
                  !isNaN(item.nh3_lowest) && nh3_low.push( Number(item.nh3_lowest)) || nh3_low.push(null);
                
                  !isNaN(item.h2s_average) && h2s_time.push(item.checkDate.substring(5)) || "";
                  !isNaN(item.h2s_average) && h2s_avg.push( Number(item.h2s_average)) || h2s_avg.push(null);
                  !isNaN(item.h2s_highest) && h2s_high.push( Number(item.h2s_highest)) || h2s_high.push(null);
                  !isNaN(item.h2s_lowest) && h2s_low.push( Number(item.h2s_lowest)) || h2s_low.push(null);

                  
                })

                this.trendData = {
                  time_array: time_array,

                  temp_time:temp_time,
                  temp_avg: temp_avg,
                  temp_low: temp_low,
                  temp_high: temp_high,

                  w_temp_avg: w_temp_avg,
                  w_temp_low: w_temp_low,
                  w_temp_high: w_temp_high,

                  hum_time:hum_time,
                  hum_avg: hum_avg,
                  hum_low: hum_low,
                  hum_high: hum_high,

                  co2_time:co2_time,
                  co2_avg: co2_avg,
                  co2_low: co2_low,
                  co2_high: co2_high,

                  nh3_time:nh3_time,
                  nh3_avg: nh3_avg,
                  nh3_low: nh3_low,
                  nh3_high: nh3_high,

                  h2s_time:h2s_time,
                  h2s_avg: h2s_avg,
                  h2s_low: h2s_low,
                  h2s_high: h2s_high,
                }
            
                // console.log(this.trendData.h2s_time)
              }else{
                // console.error("res.data는 배열이 아닙니다. 데이터:", res.data);
              }
            } 
              this.$store.commit("resMessage",res.message);
              let cookie_info = { farm: this.farm, building: this.building, room: this.room, showList:this.showList, term : this.term };
              VueCookies.set("barometer_info" ,cookie_info,"30d");

            } else {
              alert(res.message);
            }
            this.loading = false;
            // this.$refs.room.focus();

          }).catch( (err) => {  // API 오류 처리
              console.log("room24hoursView API 호출 오류",err)
              alert(err);
              this.loading = false;
          }
        )
      } 
    },
    // 데이터 체크 (일별)
    hasDataForChart(type) {
      return this.trendData[`${type}_time`] && this.trendData[`${type}_time`].length > 0;
    },
    // 일별 데이터 그려주기
    getChartData(dataKey) {
      const { type, color } = dataKey;
      return {
        labels: this.trendData[`${type}_time`] || [],
        datasets: [
          {
            label: `${dataKey.label} 평균`,
            data: this.trendData[`${type}_avg`] || [],
            borderColor: color,
            fill: false,
          },
          {
            label: `${dataKey.label} 최고`,
            data: this.trendData[`${type}_high`] || [],
            borderColor: "rgba(239, 68, 68, 0.5)",
            borderDash: [5, 5],
            fill: false,
          },
          {
            label: `${dataKey.label} 최저`,
            data: this.trendData[`${type}_low`] || [],
            borderColor: "rgba(29, 78, 216, 0.5)",
            borderDash: [5, 5],
            fill: false,
          },
        ],
      };
    },
    Report() {
      const today = new Date();
      const hours = today.getHours();
      const minutes = today.getMinutes();
      const filename =
        this.term < 2
          ? `시간 데이터_${hours}시 ${minutes}분.xlsx`
          : `일별 데이터_${hours}시 ${minutes}분.xlsx`;

      // 테이블 참조
      if (this.term < 2) {
        const timeTableRef = this.$refs.timeTable;
        if (timeTableRef) {
          const tableElement = timeTableRef.$el.querySelector('table');
          const excelData = Xlsx.utils.table_to_sheet(tableElement);
          const workBook = Xlsx.utils.book_new();
          Xlsx.utils.book_append_sheet(workBook, excelData, '시간 데이터');
          Xlsx.writeFile(workBook, filename);
        } else {
          console.warn('timeTable 참조가 없습니다.');
        }
      } else {
        const dailyTableRef = this.$refs.dailyTable;
        if (dailyTableRef) {
          const headerRow1 = ['날짜'];
          const headerRow2 = [''];
          this.dailyTableHeaders.forEach((item) => {
            headerRow1.push(item.label, '', '');
            headerRow2.push(
              '최고',
              '최저',
              '평균'
            );
          });

          const dataRows = this.reportDailyData.map((data) => {
            const row = [data.checkDate]; // 날짜 추가
            this.dailyTableHeaders.forEach((item) => {
              row.push(
                data[`${item.type}_highest`] || "-", // 최고값
                data[`${item.type}_lowest`] || "-", // 최저값
                data[`${item.type}_average`] || "-" // 평균값
              );
            });
            return row;
          });
          
          const sheetData = [headerRow1, headerRow2, ...dataRows];
          const workBook = Xlsx.utils.book_new();
          const sheet = Xlsx.utils.aoa_to_sheet(sheetData);
          Xlsx.utils.book_append_sheet(workBook, sheet, '일별 데이터');
          Xlsx.writeFile(workBook, filename);
        } else {
          console.warn('dailyTable 참조가 없습니다.');
        }
      }
    },
    filterDailyHeader(){
      let baseItems = [
        { label: '온도', type: 'temp' },
        { label: '습도', type: 'hum' },
      ];

      // 중복 추가 방지 함수
      const duplicationValue = (item) => {
        if (!baseItems.some(i => i.type === item.type)) {
          baseItems.push(item);
        }
      };

      // 데이터 존재 여부 확인
      // const nh3Data = this.listData_daily.some(item => item.nh3_average !== undefined && item.nh3_average !== null && item.nh3_average !== '-');
      // const co2Data = this.listData_daily.some(item => item.co2_average !== undefined && item.co2_average !== null && item.co2_average !== '-');
      // const h2sData = this.listData_daily.some(item => item.h2s_average !== undefined && item.h2s_average !== null && item.h2s_average !== '-');

      // // 서비스 조건과 데이터 존재 여부에 따라 항목 추가
      // if (this.services.deodorizer) {
      //   if (co2Data) duplicationValue({ label: '이산화탄소', type: 'co2' });
      //   if (nh3Data) duplicationValue({ label: '암모니아', type: 'nh3' });
      //   if (h2sData) duplicationValue({ label: '황화수소', type: 'h2s' });
      // }

      // if (this.services.fancontrol) {
      //   if (co2Data) duplicationValue({ label: '이산화탄소', type: 'co2' });
      //   if (nh3Data) duplicationValue({ label: '암모니아', type: 'nh3' });
      // }

      // if (this.services.esg) {
      //   if (co2Data) duplicationValue({ label: '이산화탄소', type: 'co2' });
      //   if (nh3Data) duplicationValue({ label: '암모니아', type: 'nh3' });
      // }
      const hasData = (key) => 
      this.listData_daily.some(item => item[key] !== undefined && item[key] !== null && item[key] !== '-');

      // 존재하는 값에 따라 항목 추가
      if (hasData('co2_average')) duplicationValue({ label: '이산화탄소', type: 'co2' });
      if (hasData('nh3_average')) duplicationValue({ label: '암모니아', type: 'nh3' });
      if (hasData('h2s_average')) duplicationValue({ label: '황화수소', type: 'h2s' });

      return baseItems;
    },
    async comboFarms() {
      await Apis.comboFarms({
        company_cd: "",
        new_version : true,
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            this.farmItems = [];
            for (let i in res.data) {
            this.farmItems.push({
              company_cd: res.data[i].company.code, 
              company_name: res.data[i].company.name, 
              code: res.data[i].farm.code,
              name: res.data[i].farm.name,
              biz: res.data[i].farm.biz,
              no: res.data[i].farm.no,
              kepco: res.data[i].farm.kepco
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboFarms API 호출 오류",err)
        }
      ) 
    },
    changeFarm() {   
      if (this.farm && this.farm.biz) {
      this.farmBiz = this.farm.biz; // 농장의 biz 정보를 저장
      this.updateBizNames(this.farmBiz); // 농장 선택 시 biz 이름 업데이트
      } else {
        // farm이 선택되지 않으면 기본값으로 초기화
        this.farmBiz = null;
        this.bizBuilding_name = "사업장";
        this.bizRoom_name = "위치";
      }

      // 하위 선택 초기화
      this.building = null;
      this.room = null;
    },
    async comboBuildings() {
      await Apis.comboBuildings({
        company_cd:this.company &&  this.company.code || "",
        farm_cd: this.farm && this.farm.code || "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            // console.log(res)
            this.buildingItems = [];
            for (let i in res.data) {
            this.buildingItems.push({
              company_cd: res.data[i].company_cd, 
              company_name: res.data[i].company_name, 
              farm_cd: res.data[i].farm_cd, 
              farm_name: res.data[i].farm_name, 
              code: res.data[i].building_cd,
              name: res.data[i].building_name,
              biz : res.data[i].farm_biz
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboBuildings API 호출 오류",err)
        }
      ) 
    },
    changeBuilding() { 
      // if (this.building && this.building.company_cd) {
      //   this.company = { code: this.building.company_cd, name: this.building.company_name };
      //   this.farm = { code: this.building.farm_cd, name: this.building.farm_name, biz:this.building.biz };
      // }
      // 하위 항목 초기화
      this.room = {};

    },
    async comboRooms() {
      await Apis.comboRooms({
        company_cd:this.company &&  this.company.code || "",
        farm_cd: this.farm && this.farm.code || "",
        building_cd: this.building && this.building.code || "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            this.roomItems = [];
            for (let i in res.data) {
            this.roomItems.push({
              company_cd: res.data[i].company_cd, 
              company_name: res.data[i].company_name, 
              farm_cd: res.data[i].farm_cd, 
              farm_name: res.data[i].farm_name, 
              building_cd: res.data[i].building_cd, 
              building_name: res.data[i].building_name, 
              code: res.data[i].room_cd,
              name: res.data[i].room_name,
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboRooms API 호출 오류",err)
        }
      ) 
    },
    changeRoom() {      // 하위콤보 선택시 상위 콤보 동시 세팅
      if (this.room && this.room.company_cd) {
        this.company = {code: this.room.company_cd, name: this.room.company_name};
        this.farm = {code: this.room.farm_cd, name: this.room.farm_name};
        this.building = {code: this.room.building_cd, name: this.room.building_name};
      }
    },

    getLabel(value) {
      switch (value) {
        case 'temp': return '온도 ℃';
        case 'w_temp': return '외기온도 ℃';
        case 'hum': return '습도 %';
        case 'co2': return '이산화탄소 ppm';
        case 'nh3': return '암모니아 ppm';
        case 'h2s': return '황화수소 ppm';
        default: return '';
      }
    }

  }  // -----------methods 

}
</script>

<style scoped lang="scss">
.site_content_barometer{
  padding:0 !important;
  width: 90% !important;
  max-width: 1500px !important;
  margin: 0 auto !important;
}
@import '@/style/base.scss';
.combo_box{
  width:270px;
  display:flex;
  margin-top:5px;
}
.select_farm{
  width:230px !important;
  margin-right:5px !important;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3); 
  border-radius: 10px;
}
.select_building , .select_room{
  width:200px !important;
  margin-right:5px !important;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3); 
  border-radius: 10px;
}
.value_container{
  display:flex;
  margin-top:10px;
  width:80%;
  // justify-content: space-between;
}
.barometer_container{
  margin-top:10px;
}
.search{
  min-width:250px;
  margin-top:10px !important;
  margin-right:10px !important;
  margin-left:10px !important;
}
::v-deep .search > .v-input__control > .v-input__slot{
  background-color: transparent !important;
}
.report__btn{
  background-color:$main-color !important;
  color:white !important;
  letter-spacing: -1px;
  border-radius: 30px;
  min-width:95px;
  max-height:60px;
}
.label{
  background-color: #E7EDFD;
  font-weight:500;
  letter-spacing: -1px;
  padding:5px;
  border-radius: 5px;
}
.timebar{
  min-width:350px;
  margin-right:5px;
}
@media screen and (max-width: 768px) {
  .combo_box{
    flex-direction: column;
  }
  .select_building{
    width:150px !important;
  }
  .select_room{
    width:180px !important;
  }
  .select_room{
    margin-top:10px;
  }
  .mb-combo{
    display: flex;
    margin-top:10px;
  }
  .timebar{
    min-width:250px !important;
    height:40px;
  }
  .value_container{
    flex-direction: column;
    justify-content: center !important;
    // width:480px;
    width:100% !important;
    // min-width:480px !important;
  }
  .mb-col{
    flex-direction: column;
  }
  .search, .report__btn{
    display: none;
  }

}
</style>